// eslint-disable-next-line no-restricted-imports
import { makeLocalUrl } from 'util/url';
import genericNormalizer, { normalizeDate } from './generic';
import { membershipsFromResponse } from './memberships';

// eslint-disable-next-line no-restricted-imports
import {
  BoardBackgroundModel,
  BoardCreationMethod,
  BoardModel,
  BoardPreferencesModel,
  BoardResponse,
  BoardResponsePrefs,
  BoardStarModel,
  MemberBoardStar,
} from 'types';

import { normalizeImagePreviews } from './image-preview';

export const normalizeBoardBackgroundPrefs = genericNormalizer<
  BoardResponsePrefs,
  BoardBackgroundModel
>(({ from, has }) => ({
  bottomColor: from('backgroundBottomColor'),
  brightness: from('backgroundBrightness'),
  color: from('backgroundTopColor'),
  tile: from('backgroundTile'),
  url: from('backgroundImage'),
  scaled: has(
    'backgroundImageScaled',
    (scaled) => (scaled ? normalizeImagePreviews(scaled) : []),
  ),
}));

export const normalizeBoardPrefs = genericNormalizer<
  BoardResponsePrefs,
  BoardPreferencesModel
>(({ from }) => ({
  cardCovers: from('cardCovers'),
  permissionLevel: from('permissionLevel'),
  comments: from('comments'),
}));

export const normalizeBoard = genericNormalizer<BoardResponse, BoardModel>(
  ({ from, has, combine }) => ({
    background: has('prefs', (prefs) => normalizeBoardBackgroundPrefs(prefs)),
    closed: from('closed'),
    creationMethod: has(
      'creationMethod',
      (method) => method as BoardCreationMethod,
    ),
    dateLastActivity: has('dateLastActivity', normalizeDate),
    dateLastView: has('dateLastView', normalizeDate),
    id: from('id'),
    idTeam: from('idOrganization'),
    isStarred: from('starred'),
    isUnread: combine(
      ['dateLastView', 'dateLastActivity'],
      ({ dateLastView, dateLastActivity }) => dateLastView < dateLastActivity,
    ),
    memberships: membershipsFromResponse,
    name: from('name'),
    prefs: has('prefs', (prefs) => normalizeBoardPrefs(prefs)),
    shortLink: from('shortLink'),
    url: ({ id, url }) => (url !== undefined ? makeLocalUrl(url) : `/b/${id}`),
  }),
);

export const normalizeBoardStar = genericNormalizer<
  MemberBoardStar,
  BoardStarModel
>(({ from, clientOnly }) => ({
  deleted: clientOnly(),
  id: from('id'),
  idBoard: from('idBoard'),
  pos: from('pos'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/board.ts